module.exports = __webpack_public_path__ + "static/media/faq.5397a2be.pdf";